// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonActions = {
  all: "全部",
  save: "保存",
  restoreDefault: "恢复默认",
  cancel: "取消",
  confirm: "确认",
  view: "查看",
  edit: "编辑",
  back: "返回",
  close: "关闭",
  logout: "退出登录",
  changePassword: "修改密码",
  exitImpersonation: "退出附身",
  add: "添加",
  create: "新建",
  upload: "上传",
  import: "批量导入",
  delete: "删除",
  destroy: "销毁",
  confirmDelete: "确认删除",
  publish: "发布",
  preview: "预览",
  viewDetail: "查看",
  saveChanges: "保存更新",
  updatePassword: "更新密码",
  search: "查询",
  reset: "重置",
  prevStep: "上一步",
  nextStep: "下一步",
  viewAll: "查看全部",
  viewLoginOnly: "仅看登录日志",
  run: "运行",
  stop: "停止",
  share: "共享",
  copy: "复制",
  download: "下载",
  archive: "归档",
  restore: "恢复",
  enable: "启用",
  disable: "停用",
  retry: "重试",
  generate: "生成",
  configure: "配置",
  commit: "提交",
  compare: "对比",
  resetPassword: "重置密码",
  unlock: "解锁",
  lock: "锁定",
  extend: "延长",
  refresh: "刷新",
  enter: "进入",
  open: "打开",
  more: "更多",
  select: "选择",
  clear: "清空",
  filtered: "已筛选",
  selectFile: "选择文件",
  selectCurrentPage: "全选",
  selectAcrossPagesMax: "跨页全选",
  clearSelection: "取消选择",
  batchActions: "批量操作",
} as const;

export const commonSemanticActionLabels = {
  destroy: commonActions.destroy,
  generate: commonActions.generate,
  configure: commonActions.configure,
  commit: commonActions.commit,
  compare: commonActions.compare,
  resetPassword: commonActions.resetPassword,
  unlock: commonActions.unlock,
  lock: commonActions.lock,
  extend: commonActions.extend,
} as const;
